import { Hero } from "../components/Hero";
import { Capabilities } from "../components/Capabilities";
import { Products } from "../components/Products";
import { RnD } from "../components/RnD";
import { GlobalProjects } from "../components/GlobalProjects";
import { Certifications } from "../components/Certifications";
import { Careers } from "../components/Careers";
import { SEO } from "../components/SEO";

export function Home() {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Technostud Engineering",
    "url": "https://technostud-engineering.pages.dev",
    "logo": "https://technostud-engineering.pages.dev/og-image.jpg",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-9313286536",
      "contactType": "sales",
      "email": "inquiry@technostud.com"
    }
  };

  return (
    <>
      <SEO schema={orgSchema} />
      <main>
        <Hero />
        <Capabilities />
        <Products />
        <RnD />
        <GlobalProjects />
        <Certifications />
        <Careers />
      </main>
    </>
  );
}
